import { render, staticRenderFns } from "./difff.vue?vue&type=template&id=04267506&scoped=true"
import script from "./difff.vue?vue&type=script&lang=js"
export * from "./difff.vue?vue&type=script&lang=js"
import style0 from "./difff.vue?vue&type=style&index=0&id=04267506&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04267506",
  null
  
)

export default component.exports